import useRequest from './use-req';
import { signOut } from '../../utils/function';

// Calls the confirmed POST /auth/auth/logout so the token is actually revoked server-side
// (see signOut's own note in utils/function.tsx — before this, logout was client-only and the
// token stayed valid until it naturally expired). Fire-and-forget: the request is sent, but
// local sign-out (clearing storage, redirecting) never waits on or fails because of it — a
// slow or unreachable logout endpoint shouldn't leave the user stuck mid-click.
export default function useLogout() {
  const authToken = localStorage.getItem('authToken');
  const { makeRequest: logoutRequest } = useRequest('/auth/auth/logout', 'POST', {
    Authorization: authToken ? `Bearer ${authToken}` : undefined,
  });

  return function logout() {
    logoutRequest().catch(() => {
      // Ignored — local sign-out below proceeds regardless of whether the server call
      // actually succeeded.
    });
    signOut();
  };
}
